import React, { useState } from 'react';
import { Button } from '../menuElements/Button';
import { Link } from 'react-router-dom';
import './Navbar.css';
import Dropdown from '../menuElements/Dropdown';
import { menuManagement, menuAdministration, menuUser } from '../menuElements/MenuItems';
import logo from '../../assets/images/logo.png';
import { useAuthContext } from '../../hooks/useAuthContext';


function Navbar() {
  const [click, setClick] = useState(false);
  const [dropdown1, setDropdown1] = useState(false);
  const [dropdown2, setDropdown2] = useState(false);
  const [dropdown3, setDropdown3] = useState(false);
  const { user } = useAuthContext();
  const closeMobileMenu = () => setClick(false);
  const filterMenuItems = (item) => item.permissions?.some((permission) => user?.permissions?.administrator || user?.permissions?.[permission]);

  return (
    <nav className='navbar'>
      <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
        <img src={logo} alt='Logo' />
      </Link>
      <ul className={click ? 'nav-menu active' : 'nav-menu'}>
        {user && (
          <>
            <li className='nav-item'>
              <Link to='/login' className='nav-links' onClick={closeMobileMenu}>
                Strona główna
              </Link>
            </li>
            <li className='nav-item' onMouseEnter={setDropdown1.bind(null, true)} onMouseLeave={setDropdown1.bind(null, false)}>
              <Link to='' className='nav-links' onClick={closeMobileMenu}>
                Zarządzanie <i className='fas fa-caret-down' />
              </Link>
              {dropdown1 && <Dropdown menuItems={menuManagement.filter(filterMenuItems)} />}
            </li>
            <li className='nav-item' onMouseEnter={setDropdown2.bind(null, true)} onMouseLeave={setDropdown2.bind(null, false)}>
              <Link to='' className='nav-links' onClick={closeMobileMenu}>
                Administracja <i className='fas fa-caret-down' />
              </Link>
              {dropdown2 && <Dropdown menuItems={menuAdministration.filter(filterMenuItems)} />}
            </li>
            <li className='nav-item' onMouseEnter={setDropdown3.bind(null, true)} onMouseLeave={setDropdown3.bind(null, false)}>
              <Link to='' className='nav-links' onClick={closeMobileMenu}>
                {user.userName} <i className='fas fa-caret-down' />
              </Link>
              {dropdown3 && <Dropdown menuItems={menuUser.filter(filterMenuItems)} />}
            </li>
          </>
        )}
        <li>
          <Link to='/login' className='nav-links-mobile' onClick={closeMobileMenu}>
            {user ? 'Wyloguj się' : 'Zaloguj się'}
          </Link>
        </li>
      </ul>
      <Button />
    </nav>
  );
}

export default Navbar;
